// Real donations: campaigns come from Supabase; a Donate hands off to a Stripe
// Checkout session created server-side by the ihsanone-pay service (the Stripe
// secret never touches the browser). Signed-in members get their donation tied
// to them + Ihsan Points; anonymous giving is allowed too.
import { getAccessToken, SUPABASE_ANON } from './session';

const SB = (process.env.REACT_APP_SUPABASE_URL
  || 'https://yuftrqcahapyrblxvkns.supabase.co').replace(/\/$/, '') + '/rest/v1';
const PAY = (process.env.REACT_APP_PAY_URL
  || 'https://ihsanone-pay-jgmy2ghs6a-as.a.run.app').replace(/\/$/, '');

export async function getCampaigns() {
  try {
    const res = await fetch(`${SB}/campaigns?select=slug,title,blurb,category,goal_cents,raised_cents,min_cents,suggested&order=sort`,
      { headers: { apikey: SUPABASE_ANON } });
    if (!res.ok) return [];
    return (await res.json()) || [];
  } catch { return []; }
}

// Kicks off a real donation: creates the Checkout session and redirects the
// browser to Stripe. Returns { ok, error } only on failure (success = redirect).
export async function startDonation(slug, amountCents) {
  try {
    const token = await getAccessToken();
    const headers = { 'content-type': 'application/json' };
    if (token) headers.authorization = `Bearer ${token}`;
    const res = await fetch(`${PAY}/create-checkout`, {
      method: 'POST', headers,
      body: JSON.stringify({ campaign_slug: slug, amount_cents: amountCents }),
    });
    const d = await res.json().catch(() => ({}));
    if (res.ok && d.url) { window.location.href = d.url; return { ok: true }; }
    return { ok: false, error: d.detail || 'Could not start the donation. Please try again.' };
  } catch (e) {
    return { ok: false, error: 'Network error. Please try again.' };
  }
}

// The signed-in member's completed donations (Me tab).
export async function getMyDonations() {
  try {
    const token = await getAccessToken();
    if (!token) return [];
    const res = await fetch(`${SB}/rpc/my_donations`, {
      method: 'POST',
      headers: { 'content-type': 'application/json', apikey: SUPABASE_ANON, authorization: `Bearer ${token}` },
      body: '{}',
    });
    if (!res.ok) return [];
    return (await res.json()) || [];
  } catch { return []; }
}
